import { useEffect, useRef } from "react";
import type { WikiPagePublic } from "@softmax/observatory-client/types";
import type { WikiViewProps } from "@softmax/web-ux/wiki";

export function useWikiHashNavigation({
  page,
  mode,
  pageSlug,
}: {
  readonly page: WikiPagePublic | null;
  readonly mode: WikiViewProps["mode"];
  readonly pageSlug: string;
}) {
  const settledHash = useRef<string | null>(null);
  useEffect(() => {
    if (!page || mode !== "read") return;

    const raw = window.location.hash.slice(1);
    const key = `${pageSlug}#${raw}`;

    if (!raw || settledHash.current === key) return;

    let id: string;

    try {
      id = decodeURIComponent(raw);
    } catch {
      id = raw;
    }

    const target = document.getElementById(id) ?? document.getElementById(raw);

    if (target) {
      settledHash.current = key;
      target.scrollIntoView();
    }
  }, [page, mode, pageSlug]);
}
